import {ContentBox} from '@hconnect/common/components'
import {getHighlightedTitle} from '@hconnect/common/utils'
import CloseIcon from '@mui/icons-material/Close'
import {Typography, IconButton, Stack} from '@mui/material'
import React from 'react'

import {HProduceTask} from '../../types'

type Props = {
  title: string
  onClose: (original?: HProduceTask, editVersion?: HProduceTask) => void
  freeSearchText?: string
  sourceAppInfo?: React.ReactNode
  metaAnnotations?: React.ReactNode
  menuActions?: React.ReactNode
  children?: React.ReactNode
}

const getTaskTitle = (title: string, freeSearchText?: string) =>
  freeSearchText ? getHighlightedTitle(title, freeSearchText) : title

export const TaskDetailsCardLayout: React.FC<Props> = (props) => {
  const {title, onClose, freeSearchText, sourceAppInfo, metaAnnotations, menuActions, children} =
    props

  return (
    <ContentBox
      data-test-id="task-details"
      mode="max100PercentOfParentHeight"
      bodyWithPadding
      {...(sourceAppInfo && {
        aboveTitle: sourceAppInfo
      })}
      title={
        <Typography
          component="span"
          variant="h2"
          data-test-id="task-details-title"
          display="flex"
          alignItems="center"
        >
          {getTaskTitle(title, freeSearchText)}
        </Typography>
      }
      afterTitle={
        <>
          {menuActions}
          <IconButton onClick={() => onClose()} data-test-id="task-details-close">
            <CloseIcon color="primary" />
          </IconButton>
        </>
      }
      headerSx={{paddingBottom: 0}}
    >
      <Stack spacing={2} useFlexGap>
        <Stack>{metaAnnotations}</Stack>
        {children}
      </Stack>
    </ContentBox>
  )
}
